//==============================================================================
// Device Container
//
// Container module that displays content only for selected device
//==============================================================================
import * as React from 'react';

import { isMobile, VariantType } from '@msdyn365-commerce-modules/utilities';

import { IDeviceContainerData } from './device-container.data';
import { IDeviceContainerProps } from './device-container.props.autogenerated';

//==============================================================================
// CLASS DEFINITION
//==============================================================================
/**
 * DeviceContainer component
 * @extends {React.PureComponent<IDeviceContainerProps<IDeviceContainerData>>}
 */
//==============================================================================
class DeviceContainer extends React.PureComponent<IDeviceContainerProps<IDeviceContainerData>> {

    //==========================================================================
    // PUBLIC METHODS
    //==========================================================================

    //------------------------------------------------------
    // Render function
    //------------------------------------------------------
    public render(): JSX.Element | null {
        return this._displayContent();
    }

    //==========================================================================
    // PRIVATE METHODS
    //==========================================================================

    //------------------------------------------------------
    //------------------------------------------------------
    private _displayContent(): JSX.Element | null {
        const { config, slots } = this.props;
        const hasSlots = slots && slots.contentBlock && slots.contentBlock.length;

        // Check current viewport size
        const viewport = isMobile({ variant: VariantType.Browser, context: this.props.context.request });
        const isMobileView = viewport === 'xs';

        if (hasSlots) {
            return (
                <React.Fragment>
                    {/* Render content according to selected device */}
                    {((config.device === 'desktop' && !isMobileView) || (config.device === 'mobile' && isMobileView)) &&
                        this._renderSlotItems(slots.contentBlock)
                    }
                </React.Fragment>
            );
        }

        // No slots, so there's nothing to do
        return null;
    }

    //------------------------------------------------------
    //------------------------------------------------------
    private _renderSlotItems(items: React.ReactNode[]): JSX.Element {
        return (
            <React.Fragment>
                {items.map((slot: React.ReactNode, index: number) => (
                    <React.Fragment key={index}>
                        {slot}
                    </React.Fragment>
                ))}
            </React.Fragment>
        );
    }
}

export default DeviceContainer;
